import React, { Component } from 'react'
import {
    Route,
    Redirect,
} from 'react-router-dom'
import {
    authedUserConnect,
    withRouter,
} from '../../validator'
import { submitWebViewEventWithUserData } from '../../admin/reducers/auth'
import { isWebView } from '../../admin/actions'

@withRouter()
@authedUserConnect()
export default class UnloggedRoute extends Component {
    /**
     * On mount send user credentials into webview
     */
    componentDidMount() {
        const { authedUser } = this.props

        if (authedUser && isWebView()) {
            submitWebViewEventWithUserData()
        }
    }

    /**
     * Render unlogged route
     *
     * @return {*}
     */
    render() {
        if (this.props.authedUser) {
            return <Redirect to='/' />
        }

        return <Route {...this.props} />
    }
}
